import { Typography } from '@mesa-labs/mesa-ui';
import styled from 'styled-components';

export default styled(Typography.Title)`
  color: #0E121B;
  font-family: ${(props) => props.theme.fonts.grotesk};
  font-size: 32px;
  font-style: normal;
  font-weight: 500;
  line-height: 40px;
  padding: 12px 0px 24px 0px;
`;